import { RouteComponentProps } from "@reach/router";
import React from "react";
import { useSelector } from "react-redux";
import { selectPanos } from "reducers/auth";
import PanoramaItem from "./PanoramaItem";
import { parsePanoramaURL } from "./parsePanoramaURL";

const ViewPanoramas: React.FC<RouteComponentProps> = () => {
  const details = useSelector(selectPanos);
  return (
    <>
      <div className="PageWrapper">
        <div className="ViewPanoramas WidthContent HeightContent">
          <h1>View Scout Spheres</h1>
          {details ? (
            details.map((farm, idx) => (
              <PanoramaItem
                key={`PANORAMA_ITEM_${idx}`}
                title={farm.farm_name}
                targetUrl={parsePanoramaURL(farm.pano_guid, farm.scene_index)}
              />
            ))
          ) : (
            <h2 className="NoResults">No Scout Spheres available</h2>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewPanoramas;
